import { Injectable } from '@angular/core';
import { FeatureEnabledQuery } from '@queries/generated';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeaturesService {
  constructor(public featureEnabledQuery: FeatureEnabledQuery) {}

  featureEnabled = (name: string) => {
    return this.featureEnabledQuery.watch({ name }).valueChanges.pipe(map(({ data }) => data.featureEnabled));
  };
}
